export default __webpack_public_path__ + "static/media/lead001_sp.a38dc777.png";